/**
 * Calculadora de Quantidade Kaatop para Shopify (Tema Dawn)
 * v2 — Sincronização bidirecional: área ↔ quantidade
 */
(function() {
  const rendimentoPorPeca = 0.9;

  const allowedProductHandles = [
    'kaatop-telha-trapezoidal-termica-sanduiche-plantavel-nucleo-em-eps-80-mm',
    'kaatop-telha-trapezoidal-termica-1-2-sanduiche-plantavel-nucleo-em-eps-80-mm'
  ];

  function createCalculator() {
    const currentProductHandle = window.location.pathname.split('/products/')[1]?.split('/')[0];
    if (!allowedProductHandles.includes(currentProductHandle)) return;
    // Inserir antes do bloco de CEP/entrega, ou antes dos botões se CEP não existir
    const cepSection = document.getElementById('kaatop-entrega-section');
    const target = cepSection || document.querySelector('.product-form__buttons');
    if (!target || document.getElementById('kaatop-calc-container')) return;

    const container = document.createElement('div');
    container.id = 'kaatop-calc-container';
    container.style.cssText = 'margin: 20px 0; padding: 15px; border: 1px solid #5B8C00; border-radius: 8px; background-color: #f9f9f9; font-family: sans-serif;';
    container.innerHTML = `
      <h3 style="margin-top: 0; color: #5B8C00; font-size: 16px;">Calculadora de Quantidade</h3>
      <p style="font-size: 14px; margin-bottom: 10px;">Informe a área total do seu projeto:</p>
      <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 15px;">
        <input type="number" id="kaatop-area-input" placeholder="Ex: 50" style="padding: 8px; border: 1px solid #ccc; border-radius: 4px; width: 80px;">
        <span style="font-size: 14px;">m²</span>
      </div>
      <div id="kaatop-result" style="display: none; padding: 10px; background: #f0f5e8; border-radius: 4px; border-left: 4px solid #5B8C00;">
        <p style="margin: 0; font-size: 14px;">Você precisará de:</p>
        <p style="margin: 5px 0; font-weight: bold; font-size: 18px; color: #5B8C00;"><span id="kaatop-qty-val">0</span> peças</p>
        <p style="margin: 0; font-size: 12px; color: #666;">(Cálculo baseado no rendimento exato de 0.9m² por peça)</p>
      </div>
    `;
    target.parentNode.insertBefore(container, target);

    const areaInput = document.getElementById('kaatop-area-input');
    const resultDiv = document.getElementById('kaatop-result');
    const qtySpan   = document.getElementById('kaatop-qty-val');

    // Flag para evitar loop infinito entre os dois listeners
    let atualizando = false;

    // ── Sentido 1: área → quantidade ──
    areaInput.addEventListener('input', function() {
      if (atualizando) return;
      atualizando = true;

      const area = parseFloat(this.value);
      if (area > 0) {
        const qtdNecessaria = Math.ceil(area / rendimentoPorPeca);
        qtySpan.innerText = qtdNecessaria;
        resultDiv.style.display = 'block';

        // Atualiza o input nativo de quantidade do Shopify
        const shopifyQtyInput = document.querySelector('input[name="quantity"]');
        if (shopifyQtyInput) {
          shopifyQtyInput.value = qtdNecessaria;
          // Dispara evento para o Dawn reconhecer a mudança
          shopifyQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else {
        resultDiv.style.display = 'none';
      }

      atualizando = false;
    });

    // ── Sentido 2: quantidade → área ──
    function syncQtyToArea(qty) {
      if (qty > 0) {
        const areaEquivalente = (qty * rendimentoPorPeca).toFixed(1);
        areaInput.value = areaEquivalente;
        qtySpan.innerText = qty;
        resultDiv.style.display = 'block';
      } else {
        areaInput.value = '';
        resultDiv.style.display = 'none';
      }
    }

    function attachQtyListener() {
      const shopifyQtyInput = document.querySelector('input[name="quantity"]');
      if (!shopifyQtyInput) return;

      // Ao sair do campo (blur) — cobre digitação manual
      shopifyQtyInput.addEventListener('blur', function() {
        if (atualizando) return;
        atualizando = true;
        syncQtyToArea(parseInt(this.value));
        atualizando = false;
      });

      // Ao pressionar Enter no campo de quantidade
      shopifyQtyInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          if (atualizando) return;
          atualizando = true;
          syncQtyToArea(parseInt(this.value));
          atualizando = false;
        }
      });

      // Botões + e - do Dawn
      const qtyContainer = shopifyQtyInput.closest('quantity-input');
      if (qtyContainer) {
        qtyContainer.addEventListener('click', function(e) {
          if (e.target.closest('button[name="plus"]') || e.target.closest('button[name="minus"]')) {
            // Aguarda o Dawn atualizar o valor antes de ler
            setTimeout(function() {
              if (atualizando) return;
              atualizando = true;
              syncQtyToArea(parseInt(shopifyQtyInput.value));
              atualizando = false;
            }, 50);
          }
        });
      }
    }

    attachQtyListener();
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    createCalculator();
  } else {
    document.addEventListener('DOMContentLoaded', createCalculator);
  }
})();
